module.exports = __webpack_public_path__ + "static/media/Knight-horse012_3c.93d3cfb0.svg";